import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import axios from 'axios';
import { baseURL } from '../base_url';
import { PuffLoader } from 'react-spinners';
import { Form, Col, Row } from 'react-bootstrap';
import { Button, Container } from '@mui/material';
import { FaPlus } from 'react-icons/fa';
import { MdSportsGolf } from 'react-icons/md';
import Select from "react-select";


const KinesisEnroll = () => {
  const [loading, setLoading] = useState(false);
  const [vinNumber, setVinNumber] = useState('');
  const vinPattern = /^[A-HJ-NPR-Z0-9]{17}$/; 

  const loggedInUser = sessionStorage.getItem("tm_token");
  const foundUser = JSON.parse(loggedInUser);
  const [packItems, setPackItems] = useState([]);
  const [packOption, setPackOption] = useState(null);

  const handlePackChange = (selectedOption) => {
    setPackOption(selectedOption.value)
  }

  const handleVinChange = (e) => {
    let entered_vin = e.target.value;
    setVinNumber(entered_vin); // Update the VIN number immediately
    if (vinPattern.test(entered_vin)) {
        setVinNumber(entered_vin)
        axios.post(baseURL + "/get_eligible_pack_for_kinesis", {
            vin:entered_vin
        }).then((res) => {
            if (res.data.length !== 0) {
                // Assuming the response contains a list of packs in 'res.data.packs'
                const formattedPacks = res.data.map((pack) => ({
                    value: pack,
                    label: pack,
                }));
                setPackItems(formattedPacks);
            }
            else{
                setPackItems([]);
                Swal.fire({icon: 'error',
                    text: 'VIN is not eligible'})
                return;
            }
        })
    }
  }
  
  const handleSubmitForm = (e) => {
    if(vinNumber.toString().trim() === ''){
      Swal.fire({icon: 'error',
                text: 'Please enter VIN Number.'})
      return;
    }
    if(packOption.toString().trim() === ''){
      Swal.fire({icon: 'error',
                text: 'Please select pack.'})
      return;
    }
    if (!vinPattern.test(vinNumber)) {
      Swal.fire({ icon: 'error', text: 'Please enter a valid VIN Number.' });
      return;
    }
    setLoading(true);
    axios.post(baseURL + "/enroll_to_kinesis", {
      'vin': vinNumber.toString().trim(),
      'pack': packOption,
      'admin_id': foundUser['tm_id']
      }).then((res) => {
        setLoading(false);
        Swal.fire({
          icon: res.data.msg_status == 1 ? 'success' : 'error',
          title: res.data.msg
        });
      
        // Clear fields
        setVinNumber('');
        setPackOption(null); // Use null instead of empty string
        setPackItems([]);
    })
  }

  return(
    <div className='body_class'>
      {loading ? (
          <div className="loader-overlay">
              <div className="loader">
              <PuffLoader color="#00308F" loading={true} size={200} />
              </div>
          </div>
      ) : ("")}
        <div className='container-fluid'>
            <h4>Create Contract</h4>
            <div className='mt-4'>
            <div className='container-fluid'>
            <Form>
                <Form.Group as={Row} className="mb-3" controlId="formPlaintextCN">
                  <Form.Label column sm="2">
                    VIN Number *
                  </Form.Label>
                  <Col sm="5">
                    <Form.Control type='text' value={vinNumber} onChange={handleVinChange} placeholder='Enter VIN Number' />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="formPlaintextCN">
                  <Form.Label column sm="2">
                    Pack *
                  </Form.Label>
                  <Col sm="5">
                    <Select placeholder="Select Pack" 
                      options={packItems} 
                      onChange={handlePackChange} 
                      value={packItems.find(option => option.value === packOption) || null}
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="formPlaintextCN">
                  <Form.Label column sm="2"></Form.Label>
                  <Col sm="5">
                  <Button variant="contained" onClick={handleSubmitForm}><FaPlus />&nbsp;Create</Button>
                  </Col>
                </Form.Group>
              </Form>
            </div>
            </div>
        </div>
    </div>
  )  
}

export default KinesisEnroll;